import React from 'react';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import DateRange from './date-range';
import DateRangeDialog from './date-range-dialog/date-range-dialog';

/**
 * Renders DateRange component for xs+ screens.
 * Renders DateRangeDialog for xs screens
 * @returns {React.FC}
 */

const DateRangeRouter = props => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (isMobile) {
    return <DateRangeDialog {...props} />;
  }

  return <DateRange {...props} />;
};

export default DateRangeRouter;
